export const roadmapColorScheme = {
  today: {
    nub: 'danger.fg',
    marker: 'danger.muted',
  },
  customDate: {
    nub: 'fg.subtle',
    marker: 'fg.muted',
  },
  iteration: {
    nub: 'fg.subtle',
    marker: 'fg.muted',
  },
  currentIteration: {
    nub: 'accent.fg',
    marker: 'accent.muted',
  },
  iterationBreak: {
    nub: 'canvas.default',
  },
  milestone: {
    nub: 'success.fg',
    marker: 'success.muted',
  },
  divider: {
    marker: 'border.default',
  },
} as const
